// extracted by mini-css-extract-plugin
export var errorIcon = "_ns-1";
export var nameLogo = "_ns-0";